export default __webpack_public_path__ + "static/lshape-whitepaper-905e402d82e055293133f8cfd5dbbcea.webp";